'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Category = ({
  category,
  type,
  color
}) => {
  if (!category)
    return null;
  const Wrapper = type === "button" ? ButtonCategory : TextCategory;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    $color: color,
    children: category.name
  });
};
const ButtonCategory = styled__default["default"].span`
  color: ${({ $color }) => $color};
  background-color: ${({ $color }) => coreRenderer.generate($color)["100"]};
  padding: 2px 8px;
  border-radius: 1em;
`;
const TextCategory = styled__default["default"].span`
  color: ${({ $color }) => $color};

  &:after {
    content: '•';
    margin-left: 0.5em;
  }

  &:last-child:after {
    content: none;
  }
`;

exports.Category = Category;
